import { render, staticRenderFns } from "./PricingApe.vue?vue&type=template&id=223c5aae&scoped=true&"
import script from "./PricingApe.vue?vue&type=script&setup=true&lang=js&"
export * from "./PricingApe.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PricingApe.vue?vue&type=style&index=0&id=223c5aae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223c5aae",
  null
  
)

export default component.exports